module.exports = __webpack_public_path__ + "static/media/drive-logo.4ecf4455.png";